/*
    Handle style customizations based on lender settings
*/
import { useMemo } from 'react';

import { CompanyFragment } from '@willow/graphql-iso/src/portal';
import { DEFAULT_PORTAL_PRIMARY_COLOR, DEFAULT_PORTAL_SECONDARY_COLOR } from '@willow/shared-web';

import { hexToRgbA } from './utils';

// Default logo heights (matches Banner.scss defaults)
const DEFAULT_LOGO_HEIGHT = '20px'; // mobile
const DEFAULT_LOGO_HEIGHT_MD = '26px'; // desktop

// Company-specific logo height overrides
// To add a new override, add the company ID and desired heights here
const LOGO_HEIGHT_OVERRIDES: Record<string, { mobile: string; desktop: string }> = {
  '514c3422-5918-4f15-b914-269d1ef5bc31': { mobile: '30px', desktop: '40px' }, // EDUCATED_MORTGAGE_SERVICES
};

export const useStyleCustomization = (company: CompanyFragment | undefined) => {
  const primaryColor = useMemo<string | undefined>(() => company?.portalSettings?.primaryColor || undefined, [company]);
  const secondaryColor = useMemo<string | undefined>(
    () => (primaryColor ? hexToRgbA(primaryColor) : undefined),
    [primaryColor],
  );

  const logoHeightMobile = company?.id
    ? (LOGO_HEIGHT_OVERRIDES[company.id]?.mobile ?? DEFAULT_LOGO_HEIGHT)
    : DEFAULT_LOGO_HEIGHT;
  const logoHeightDesktop = company?.id
    ? (LOGO_HEIGHT_OVERRIDES[company.id]?.desktop ?? DEFAULT_LOGO_HEIGHT_MD)
    : DEFAULT_LOGO_HEIGHT_MD;

  return {
    primaryColor: primaryColor || DEFAULT_PORTAL_PRIMARY_COLOR,
    secondaryColor: secondaryColor || DEFAULT_PORTAL_SECONDARY_COLOR,
    logoHeightMobile,
    logoHeightDesktop,
  };
};
